import { ChevronDown, ChevronsDown, ChevronsUp, ChevronUp, CircleCheck, CircleDot, CircleDotDashed, CircleEllipsis } from "lucide-react";
import { TaskPriority, TaskStatus } from "types/api/tasks";

export const statusIcons = (status: TaskStatus, color: string) => {
    return {
        open: <CircleDot size={16} color={color} />,
        'in-progress': <CircleDotDashed size={16} color={color} />,
        'pending-review': <CircleEllipsis size={16} color={color} />,
        complete: <CircleCheck size={16} color={color} />,
    }[status];
};

export const priorityIcons = (priority: TaskPriority, color: string) => {
    return {
        low: <ChevronsDown size={16} color={color} />,
        medium: <ChevronDown size={16} color={color} />,
        high: <ChevronUp size={16} color={color} />,
        critical: <ChevronsUp size={16} color={color} />,
    }[priority];
};